import React, { useState, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { TiDeleteOutline } from "react-icons/ti";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import ButtonUI from "../../material-ui/ButtonUI";
import { AuthContext } from "../../../context/Auth/AuthContext";
import rejectRequestedCase from "../../../api/rejectRequestedCase";
import "../../../styles/RejectCasePopup.css";

const rejectCaseFormSchema = yup.object().shape({
  reason: yup.string().required("Reason is required field"),
});

/*** Component for rejecting the document from the pdf viewer ***/
const RejectPDFDocumentPopup = ({
  documentRequestId,
  setReqStatus,
  setDocumentViewer,
  setDocumentUpdatedToTrue,
  setDisapproveConfirmOpen,
  currentTabId,
  closeTabById,
}) => {
  const [open, setOpen] = useState(true);
  const { token } = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(rejectCaseFormSchema),
  });

  const reasonList = [
    "Wrong Document",
    "Unreadable Document",
    "Document Incomplete",
    "Document Outdated",
    "Document Not Translated",
    "Document Missing Signatures",
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDisapproveConfirmOpen(false);
  };

  const onRejectDocumentFormSubmit = async (addDocumentFormData) => {
    const rejectDocumentFormResponse = await rejectRequestedCase({
      token: token,
      docId: documentRequestId,
      reason: addDocumentFormData.reason,
    });

    if (rejectDocumentFormResponse?.code === 200) {
      setOpen(false);
      showSuccess("Document is rejected successfully");
      setReqStatus("Rejected");
      if (setDocumentViewer) {
        setDocumentViewer(false);
      }

      if (setDocumentUpdatedToTrue) {
        setDocumentUpdatedToTrue();
      }

      setDisapproveConfirmOpen(false);
      if (currentTabId) {
        closeTabById(currentTabId);
      }
    } else {
      setOpen(false);
      showError("Error while rejecting the document");
      setDisapproveConfirmOpen(false);
    }
  };

  return (
    <div className="dialog-modal">
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <TiDeleteOutline />
          </div>
          <div className="popup-header-title">Reject Document</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <FormControl className="reject-doc-select-ui">
                <InputLabel
                  className="reject-doc-select-label"
                  id="select-label"
                >
                  Reason
                </InputLabel>
                <Controller
                  control={control}
                  name="addDocCategories"
                  render={({ field: { onChange, value } }) => (
                    <Select
                      name="reason"
                      sx={{ margin: "10px 0px" }}
                      labelId="select-label"
                      variant="outlined"
                      id="simple-select"
                      value={value}
                      onChange={onChange}
                      label="Reason"
                      {...register("reason")}
                    >
                      {reasonList.map((reason) => (
                        <MenuItem key={reason} value={reason}>
                          {reason}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
              <span className="error-message">{errors["reason"]?.message}</span>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              marginTop: "0px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            variant="outlined"
            buttonText="Yes"
            style={{
              margin: "15px",
              marginTop: "0px",
              backgroundColor: "#fff",
              color: "##1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            autoFocus={true}
            handleSubmit={handleSubmit}
            onFormSubmit={onRejectDocumentFormSubmit}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RejectPDFDocumentPopup;
